

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
// 替换引入
import { hubConnection, Connection } from 'signalr-no-jquery';

@Component({ name: "index" })
export default class AppHome extends Vue {
  // 调整类型声明
  hubConnection?: Connection;
  get userId() {
    var data = this.$store.state.user.data;
    if (!data) return 0;
    return data.Id;
  }

  @Watch("userId")
  onUserIdChange(val: any) {
    //console.error("userId changed", val);
  }
  

  mounted() {
  }

}
